<template>
  <div class="support-and-footer">
    <div id="graypage">
      <div class="page_content">

<div class="support"> <h2 style="margin-bottom: 30px;"> 自社製造の美容機器（国産）販売とサービス </h2> <p> 株式会社スカンジナビアサービスの機器はすべて自社開発で、製造から組み立てまで日本国内で丁寧に行われています。<br> 高品質で安全・安心の100％国内生産のため、機器の故障は少なく、どこよりも長期間使用し続けられる耐久性の高さが特徴です。<br> パーツ管理やリペアもサービスの一貫で、何年経っても部品がすぐ手に入るのも自社生産ならではのメリットです。<br> さらに万一の故障の際は「土日祝(9:00-18:00)もサービスコール受付、48時間以内対応」というメンテナンス体制で、<br> お客様のご負担を大幅に軽減します。 </p> </div>


        <div class="support_pie">
          <div id="pie2"></div>
          <div id="pie3"></div>
          <div id="pie4"></div>
          <div id="pie5"></div>
        </div>

        <div class="support_pie_smallscreen">
          <img src="/assets/img/support_2_5detail.png" alt="販売から修理・メンテナンスまで一貫したサービス提供">
        </div>

        <div class="support">
          <img src="/assets/img/support_06.png" alt="特許と適合審査合格">
        </div>
        <div class="support">
          <img src="/assets/img/support_07_1.png" alt="導入サロン様へのサポート">
        </div>
        <div class="support_block">
          <div id="supportblock1"></div>
          <div id="supportblock2"></div>
          <div id="supportblock3"></div>
          <div id="supportblock4"></div>
        </div>

        <div class="supportblock_smallscreen">
          <img src="/assets/img/support_07_2detail.png" alt="ドクターサポート・技術指導・メニュー及び広告ツールの作成・サロン様の安定した経営と売上に貢献">
        </div>

        <div class="support">
          <img src="/assets/img/support_08.png" alt="ニーズに合わせた化粧品の開発・販売">
        </div>

        <shop-movie-partner></shop-movie-partner>

      </div>
    </div>
    <footer2></footer2>
  </div>
</template>

<script>

 export default {
   name: 'support',
   components: {
     'shop-movie-partner': () => import('../components/ShopMoviePartner.vue'),
     footer2: () => import('../components/Footer2.vue')
   },
 }
</script>

<style lang="scss" scoped>
 .support-and-footer {
   margin-top: 50px;
 }
 @media (min-width: 601px) {
   .support-and-footer {
     margin-top: 80px; /* to deal with floating menu*/
   }
 }
 .support {
   img {
     display: block;
     margin-top: 20px;
   }
 }

 @mixin pie-style() {
   width: 480px;
   height: 385px;
   opacity: 0.8;
   transition: opacity .55s ease-in-out;
 }
 @mixin pie-hover-style() {
   opacity: 1.0;
   transition: opacity .55s ease-in-out;
 }
 .support_pie {
   margin: 0;
   padding: 0;
   display: flex;
   flex-wrap: wrap;
   & #pie2 {
     @include pie-style();
     background-image: url("/assets/img/support_02.png");
   }
   & #pie2:hover {
     @include pie-hover-style();
     background-image: url("/assets/img/support_02detail.png");
   }
   & #pie3 {
     @include pie-style();
     background-image: url("/assets/img/support_03.png");
   }
   & #pie3:hover {
     @include pie-hover-style();
     background-image: url("/assets/img/support_03detail.png");
   }
   & #pie4 {
     @include pie-style();
     background-image: url("/assets/img/support_04.png");
   }
   & #pie4:hover {
     @include pie-hover-style();
     background-image: url("/assets/img/support_04detail.png");
   }
   & #pie5 {
     @include pie-style();
     background-image: url("/assets/img/support_05.png");
   }
   & #pie5:hover {
     @include pie-hover-style();
     background-image: url("/assets/img/support_05detail.png");
   }
 }
 .support_pie_smallscreen {
   display: none;
 }

 .support_block {
   margin: 0;
   padding: 0;
   display: flex;
   flex-wrap: wrap;
   & #supportblock1 {
     width: 247px;
     height: 398px;
     opacity: 0.8;
     transition: opacity .55s ease-in-out;
     background-image: url("/assets/img/support_07_2_1.png");
   }
   & #supportblock1:hover {
     opacity: 1.0;
     transition: opacity .55s ease-in-out;
     background-image: url("/assets/img/support_07_2_1detail.png");
   }
   & #supportblock2 {
     width: 213px;
     height: 398px;
     opacity: 0.8;
     transition: opacity .55s ease-in-out;
     background-image: url("/assets/img/support_07_2_2.png");
   }
   & #supportblock2:hover {
     opacity: 1.0;
     transition: opacity .55s ease-in-out;
     background-image: url("/assets/img/support_07_2_2detail.png");
   }
   & #supportblock3 {
     width: 212px;
     height: 398px;
     opacity: 0.8;
     transition: opacity .55s ease-in-out;
     background-image: url("/assets/img/support_07_2_3.png");
   }
   & #supportblock3:hover {
     opacity: 1.0;
     transition: opacity .55s ease-in-out;
     background-image: url("/assets/img/support_07_2_3detail.png");
   }
   & #supportblock4 {
     width: 288px;
     height: 398px;
     // opacity: 0.8;
     // transition: opacity .55s ease-in-out;
     background-image: url("/assets/img/support_07_2_4.png");
   }
 }

 .supportblock_smallscreen {
   display: none;
 }
 @media (max-width: 600px) {
   .support {
     img{
       width: 100%;
     }
   }
   .support_pie {
     display: none;
   }
   .support_block {
     display: none;
   }
   .support_pie_smallscreen {
     display: block;
     img {
       display: block;
       width: 100%;
     }
   }
   .supportblock_smallscreen {
     display: block;
     img {
       display: block;
       width: 100%;
     }
   }
 }
</style>
